import type { HTMLAttributes } from 'react';
import './ReadinessMeter.css';

type Tier = 'bronze' | 'silver' | 'gold' | 'platinum';

const TIER: Record<Tier, string> = {
  bronze: 'var(--div-bronze)',
  silver: 'var(--div-silver)',
  gold: 'var(--div-gold)',
  platinum: 'var(--div-platinum)',
};

export interface ReadinessMeterProps extends HTMLAttributes<HTMLDivElement> {
  division?: Tier;
  /** 0..100. */
  score?: number;
  threshold?: number;
  /** Change over the trailing 7 days; shows a coloured delta when provided. */
  delta?: number;
}

export function ReadinessMeter({
  division = 'gold',
  score = 0,
  threshold = 80,
  delta,
  style,
  ...rest
}: ReadinessMeterProps) {
  const color = TIER[division];
  const ready = score >= threshold;
  const dStr = delta == null ? null : delta > 0 ? `+${delta}` : `${delta}`;
  return (
    <div className="uc-rm" style={style} {...rest}>
      <div className="uc-rm__top">
        <span className="uc-rm__tier" style={{ color }}>
          <span className="uc-rm__tdot" style={{ background: color }} />
          {division[0]!.toUpperCase() + division.slice(1)} readiness
        </span>
        <span className="uc-rm__score">
          {score}
          <small>/100</small>
        </span>
      </div>
      <div className="uc-rm__track">
        <div
          className="uc-rm__fill"
          style={{ width: `${Math.max(0, Math.min(100, score))}%`, background: color }}
        />
        <div
          className="uc-rm__thresh"
          style={{ left: `${threshold}%` }}
          title={`promotion threshold ${threshold}`}
        />
      </div>
      <div className="uc-rm__foot">
        <span>{ready ? 'above promotion threshold' : `${threshold - score} to threshold`}</span>
        {dStr && (
          <span className={delta! >= 0 ? 'uc-rm__delta--up' : 'uc-rm__delta--down'}>
            {dStr} / 7d
          </span>
        )}
      </div>
    </div>
  );
}
